import { useContext, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import useRoutes from 'hooks/use-routes';
import { AuthContext } from 'state/auth';

export default function useAuthRedirects(opts = { skip: false }) {
  const { loading, isAuthenticated, originLocation, setOriginLocation } = useContext(AuthContext);
  const authenticated = isAuthenticated();
  const location = useLocation();
  const { getLocalizedRouteForPath } = useRoutes();
  const navigate = useNavigate();

  useEffect(() => {
    if (opts.skip) {
      return;
    }

    if (loading) {
      return;
    }

    if (authenticated && originLocation) {
      const nextLocation = originLocation;
      setOriginLocation(null);
      navigate(nextLocation, { replace: true });
    } else if (
      !authenticated &&
      location.pathname !== getLocalizedRouteForPath('signin') &&
      location.pathname !== getLocalizedRouteForPath('signup')
    ) {
      setOriginLocation(`${location.pathname}${location.search}`);
      navigate(getLocalizedRouteForPath('signup'), { replace: true });
    }
  }, [
    authenticated,
    loading,
    location.pathname,
    location.search,
    originLocation,
    setOriginLocation,
    getLocalizedRouteForPath,
    navigate,
    opts.skip,
  ]);
}
